module.exports = __webpack_public_path__ + "static/code_structure-50c5a84362fff4d1cba9406b8039b59a.png";